import { paymentStatusService } from "../../helpers/paymentStatusService";

export const state = {
  getAllPrePayment: [],
  prePaymentCount: "",
  getAllCompletedPayment: [],
  getAllBookingInfo: [],
  completedPaymentCount: "",
  pagination: {},
  loading: true,
};

export const mutations = {
  getAllPrePayment(state, payload) {
    state.getAllPrePayment = payload.result.data;
    state.loading = false;
    state.pagination = payload.result;
    state.prePaymentCount = payload.result.total;
  },
  getAllCompletedPayment(state, payload) {
    state.getAllCompletedPayment = payload.result.data;
    state.loading = false;
    state.pagination = payload.result;
    state.completedPaymentCount = payload.result.total;
  },
  getAllBookingInfo(state, payload) {
    state.getAllBookingInfo = payload.result;
    state.loading = false;
  },
  getPrePaymentListRequest(state) {
    state.loading = true;
  },
  getCompletedPaymentListRequest(state) {
    state.loading = true;
  },
  getPrePayment(state, payload) {
    state.user = payload.result;
  },
  getCompletedPayment(state, payload) {
    state.user = payload.result;
  },
  getPrePaymentListFailure(state) {
    state.loading = false;
  },
  getCompletedPaymentListFailure(state) {
    state.loading = false;
  },
};

export const actions = {
  async getPrePayment({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    commit("getPrePaymentListRequest");
    await paymentStatusService.getPrePayment(data).then(
      (response) => {
        commit("getAllPrePayment", response.data);
      },
      (error) => {
        commit("getPrePaymentListFailure", error, { root: true });
        dispatch("alert/error", error, { root: true });
      }
    );
  },
  async getCompletedPayment({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    commit("getCompletedPaymentListRequest");
    await paymentStatusService.getCompletedPayment(data).then(
      (response) => {
        commit("getAllCompletedPayment", response.data);
      },
      (error) => {
        commit("getCompletedPaymentListFailure", error, { root: true });
        dispatch("alert/error", error, { root: true });
      }
    );
  },
  async getBooking({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    commit("getCompletedPaymentListRequest");
    await paymentStatusService.getBooking(data).then(
      (response) => {
        commit("getAllBookingInfo", response.data);
      },
      (error) => {
        commit("getCompletedPaymentListFailure", error, { root: true });
        dispatch("alert/error", error, { root: true });
      }
    );
  },
};
export const getters = {
  loading: (state) => state.loading,
  getAllPrePayment: (state) => state.getAllPrePayment,
  prePaymentCount: (state) => state.prePaymentCount,
  getAllCompletedPayment: (state) => state.getAllCompletedPayment,
  getAllBookingInfo: (state) => state.getAllBookingInfo,
  completedPaymentCount: (state) => state.completedPaymentCount,
  pagination: (state) => state.pagination,
};
